<template>
    <div
        :data-component="$options.name"
        class="relative flex flex-col overflow-hidden transition-shadow rounded-10 hover:shadow-hover"
        :class="computedProps.backgroundClass"
    >
        <div class="relative overflow-hidden aspect-[1240/700]">
            <div
                class="absolute rounded-full w-60 h-60 top-[-15px] left-[-15px]"
                :class="computedProps.backgroundClass"
            >
                <component
                    :is="computedProps.iconComponentName"
                    class="absolute w-24 h-24 top-[22px] left-[22px]"
                ></component>
            </div>
            <slot name="image" />
        </div>
        <component
            :is="computedProps.backgroundComponentName"
            class="absolute bottom-0 right-0"
        />
        <div class="flex flex-col flex-grow gap-4 p-16 pb-24 z-content">
            <div class="font-bold text-h4">
                {{ computedProps.headlineText }}
            </div>
            <ms-click-area
                :href="href"
                :target="target"
                :rel="rel"
                :trackingData="computedProps.trackingData"
            >
                <p class="text-text-l">
                    <slot name="text" />
                </p>
            </ms-click-area>
        </div>
    </div>
</template>
<script lang="ts" src="./CsChannelTeaser.ts" />
